export class BillingChoiceData {
    amount :number=0
    name :string=""
    currency:string=""
    billingChartId:number=0


}
